import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Switch,
} from '@material-ui/core';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useInstitutions } from './Institutions';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
    width: '50%',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    width: '80%',
  },
}));

export function ToggleModules(props) {
  const { institutions } = useInstitutions();
  const [institution, setInstitution] = useState('');
  const [activeModules, setActiveModules] = useState(null);
  const classes = useStyles();
  const navigate = useNavigate();

  const handleInstitutionChange = (e) => {
    fetch(`https://api.edicionesmilenio.com/api/institutions/${e.target.value}`)
      .then((response) => response.json())
      .then((data) => {
        setInstitution(data?.data?._id);
        setActiveModules(data?.data?.activeModules);
        console.log(activeModules);
      });
  };

  const handleModuleChange = (e) => {
    const { name, checked } = e.target;
    setActiveModules({ ...activeModules, [name]: checked });
  };

  const save = () => {
    fetch(`https://api.edicionesmilenio.com/api/institutions/${institution}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ activeModules }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        navigate('/admin/institutions');
      });
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <p className={classes.formSpan}>
        Estimado usuario, desde esta sección podrás activar o desactivar los
        módulos prémium de la plataforma, recuerda que este proceso solo debe
        realizarse bajo la autorización de la gerencia general de Ediciones
        Mileno, para este proceso, basta con seleccionar la institución
        educativa y activar o desactivar los módulos deseados.
      </p>
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="institution">Institución</InputLabel>
        <Select
          labelId="institution"
          id="institution"
          name="institution"
          value={institution}
          onChange={handleInstitutionChange}
          label="Institución"
        >
          {institutions.map((institution) => (
            <MenuItem value={institution?._id}>{institution?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
      {activeModules && (
        <div className={classes.input}>
          <span>Glosario: </span>
          <Switch
            onChange={handleModuleChange}
            checked={activeModules?.glosary}
            name="glosary"
          />
          <br></br>
          <span>Recursos: </span>
          <Switch
            onChange={handleModuleChange}
            checked={activeModules?.resources}
            name="resources"
          />
          <br></br>
          <span>Talleres adicionales: </span>
          <Switch
            onChange={handleModuleChange}
            checked={activeModules?.aditionalWorkshops}
            name="aditionalWorkshops"
          />
          <br></br>
          <span>Preparar clase: </span>
          <Switch
            onChange={handleModuleChange}
            checked={activeModules?.prepareClass}
            name="prepareClass"
          />
        </div>
      )}
      <Button
        color="primary"
        className={classes.input}
        variant="contained"
        onClick={save}
      >
        Guardar
      </Button>
    </div>
  );
}
